import { Task } from 'taskarian';
import { DynamicImportError, dynamicImportError } from './Types';

export type CssVarsPonyfillModule = typeof import('css-vars-ponyfill');

export const importCssVarsPonyfillModule: Task<DynamicImportError, CssVarsPonyfillModule> =
  Task.fromPromise(() => import('css-vars-ponyfill')).mapError<DynamicImportError>(
    dynamicImportError,
  );
